import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';
import { InstagramService, INSTAGRAM_AUTH_MESSAGE } from '../services/InstagramService';
import { useCelular } from '../hooks/useCelular';
import './GoogleCalendarCallbackPage.css';

export const INSTAGRAM_STATE_KEY = 'lemeai:instagram-oauth-state';

const InstagramCallbackPage: React.FC = () => {
    const celular = useCelular();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('Conectando sua conta do Instagram...');

    useEffect(() => {
        const avisarAbridor = (success: boolean, mensagem?: string) =>
            window.opener?.postMessage(
                { type: INSTAGRAM_AUTH_MESSAGE, success, mensagem },
                window.location.origin
            );

        const run = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const state = params.get('state');
            const errorParam = params.get('error');

            const esperado = sessionStorage.getItem(INSTAGRAM_STATE_KEY);
            sessionStorage.removeItem(INSTAGRAM_STATE_KEY);

            if (errorParam || !code) {
                setStatus('error');
                setMessage('A conexão com o Instagram foi cancelada ou falhou.');
                avisarAbridor(false);
                return;
            }

            // Sem o state, um terceiro consegue fazer o usuário autorizar uma conta que não
            // é dele. O backend não guarda esse estado, então a checagem é aqui.
            if (!state || !esperado || state !== esperado) {
                setStatus('error');
                setMessage('Requisição de conexão inválida. Tente novamente pela tela de conexões.');
                avisarAbridor(false);
                return;
            }

            try {
                const resultado = await InstagramService.conectarComLoginInstagram(code);

                if (resultado.sucesso) {
                    setStatus('success');
                    setMessage('Instagram conectado com sucesso!');
                    avisarAbridor(true);
                } else {
                    setStatus('error');
                    setMessage(resultado.mensagem || 'Não foi possível conectar o Instagram.');
                    avisarAbridor(false, resultado.mensagem);
                }
            } catch {
                setStatus('error');
                setMessage('Erro de conexão ao tentar autenticar com o Instagram.');
                avisarAbridor(false);
            } finally {
                setTimeout(() => window.close(), 1800);
            }
        };

        run();
    }, []);

    return (
        <div className="google-callback-container">
            <div className="google-callback-card">
                {status === 'loading' && <FaSpinner className="spin google-callback-icon" />}
                {status === 'success' && <FaCheckCircle className="google-callback-icon success" />}
                {status === 'error' && <FaTimesCircle className="google-callback-icon error" />}
                <p>{message}</p>
                {/* Janela aberta pelo app fecha sozinha; aba solta ou app instalado no celular
                    não fecha, então a pessoa precisa de um caminho de volta. */}
                {celular && !window.opener ? (
                    status !== 'loading' && <a className="google-callback-voltar" href="/">Voltar ao app</a>
                ) : (
                    <span className="google-callback-hint">Esta janela será fechada automaticamente.</span>
                )}
            </div>
        </div>
    );
};

export default InstagramCallbackPage;
